var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-423 -2984) translate(-3 2572) translate(424 410)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#385F6C",
    d: "M2 3.834c0-.552.448-1 1-1 .192 0 .38.055.542.16l2.055 1.324C7.332 2.871 9.564 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12V3.834z",
    transform: "translate(-423 -2984) translate(-3 2572) translate(424 410)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#073748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.4,
    d: "M8 12.536L10.874 15.208 16.081 10",
    transform: "translate(-423 -2984) translate(-3 2572) translate(424 410)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBale);
export default __webpack_public_path__ + "static/media/bale.f9574143ab089c4136169f734d594426.svg";
export { ForwardRef as ReactComponent };